import React, { Fragment, useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Btn } from "../../AbstractElements";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import visileColumns from "./visibleColumns";
import AdvanceSearch from "../../CommonComponents/AdvanceSearch";
import ErrorBoundary from "../../ErrorBoundry";
import TelerikDataTable from "../../CommonComponents/TelerikDataTable";
import { useNavigate } from "react-router-dom";
import { useAuth } from "oidc-react";
import { Icon } from "@progress/kendo-react-common";

import {
  faEye,
  faPlusLarge,
  faTrash,
} from "@fortawesome/pro-duotone-svg-icons";
import {
  deleteJobAnnouncement,
  reset,
} from "../../store/jobAnnouncement/action";
// } from "../../../store/jobAnnouncement/action";
import useSortedColumns from "../../utils/useSortedColumns";
import { post, remove } from "../../_helper/api_helper";


function NotificationTemplateListing() {
  const dispatch = useDispatch();
  const {
    columns,
    loadingSearch,
    searchResults,
    ColumnsSorted,
    searchParameter,
    searchResults: { results, rowCount },
  } = useSelector((state) => state.advanceSearchv2Reducer);
  const { postingResult, loading } = useSelector(
    (state) => state.JobAnnouncementReducer
  );
  const history = useNavigate();
  const [expandedSearchResult, setexpandedSearchResult] = useState(false);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const id = "Template_notification_list";
  const { filter: storeFilter, pageSize: storePageSize } = useSelector(
    (state) => state.CommonReducer
  );
  const [page, setPage] = useState(1);
  const { userData } = useAuth();
  const [additionalWhere, setAdditionalWhere] = useState("");
  const { sort } = useSelector((state) => state?.CommonReducer) || {};
  const [sortData, setSortData] = useState(
    sort && sort[id] ? sort[id] : [{ field: "", dir: "" }]
  );

  const [searchParams, setSearchParams] = useState([]);
  const [pageSize, setPageSize] = useState(storePageSize[id] || 100);

  const [deleteData, setDeleteData] = useState(null);
  const [gg1ExportParams, setGG1ExportParams] = useState({});
  const getParamData = (data) => {
    setGG1ExportParams(data);
  };

  const handleReset = () => {
    dispatch(reset());
    reset({
      announcementId: "",
      positionNo: "",
      requirements: "",
      datePosted: "",
      dateClosed: "",
      status: "",
      announcementType: "",
    });
  };

  const handleDeleteTemplate = (templateId) => {
    const APIURL = `${process.env.REACT_APP_API_DOTNET_URL}/NotificationTemplate/NotificationTemplate/SoftDeleted?Id=${templateId}`;
    remove(APIURL, {}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem(
          "jwt_access_token"
        )}`,
      },
    })
  }


  const actions = useMemo(() => {
    return [
      {
        title: "Show Details",
        action: (props) => {
          console.log("props", props);
          return history(`/update-notification-template/${props.dataItem.ID}`);
        },
        icon: { iconName: "k-icon  k-i-eye" },
        className: "font-primary",
        style: { cursor: "pointer" },
      },
      {
        title: "delete",
        icon: { iconName: "k-icon  k-i-delete" },
        className: "font-primary",
        style: { cursor: "pointer" },
        action: (props) => {
          if (window.confirm("Are you sure to delete this?")) {
            handleDeleteTemplate(props?.dataItem?.ID)
          }
        },
      },
      // {
      //   title: "View Applications",
      //   action: (props) => {
      //     console.log("props", props);
      //     return history(`/jobapplications/${props.dataItem.ANNOUNCEMENT_ID}/applications?position=${props.dataItem.PositionTitle}`);
      //   },
      //   icon: { iconName: "k-icon  k-i-list-unordered "},
      //   className: "font-primary",
      //   style: { cursor: "pointer" },
      // },
    ];
  });

  useEffect(() => {
    if (loadingSearch) setexpandedSearchResult(true);
  }, [loadingSearch]);
  useEffect(() => {
    if (
      postingResult !== undefined &&
      Object.keys(postingResult).length > 0 &&
      loading === false
    ) {
      setDeleteData({ dt: new Date() });
    }
  }, [postingResult, loading]);
  useEffect(() => { }, [searchResults]);
  const [sortedColumns, setSortedColumns] = useSortedColumns(
    id,
    ColumnsSorted,
    columns,
    visileColumns,
    userData
  );


  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
    setPageSize(100);
  };
  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
    setPageSize(100);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };
  useEffect(() => {
    if (searchParameter[id]?.searchParams?.length > 0) {
      setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
    }
  }, [searchParameter]);
  return (
    <ErrorBoundary>
      {" "}
      <Fragment>
        <Container fluid={true}>
          <Row className="bg-primary rounded py-3 mb-3">
            <Typography variant="h5">
              <Icon
                style={{ fontSize: "25px", margin: "10px" }}
                name="file-ascx"
              />
              Notification Template List
            </Typography>
          </Row>
          <Row>
            <Col sm="12" className="page-content">
              <Card>
                <CardBody>
                  <AdvanceSearch
                    id={id}
                    gridId={id}
                    location="global" //"JobApplicant-global"
                    // location="JobApplicant-global"
                    getParamData={getParamData}
                    columnList={'*'}
                    columnRefernces={[]}
                    tableName={"vw_template_management"} //{"JA_Announcement"}
                    // tableName={"vw_Job_Applications_Announcement"} //{"JA_Announcement"}
                    searchParams={searchParams}
                    additionalWhere={additionalWhere}
                    expanded={true}
                    sortData={sortData}
                    pageNumber={page}
                    pageSize={pageSize}
                    deleteData={deleteData}
                    chooseFilterMethod={chooseFilterMethod}
                  // applicationName={"JobApplication"}
                  />
                  <Accordion expanded={expandedSearchResult}>
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      className="bg-light"
                      onClick={() =>
                        setexpandedSearchResult(!expandedSearchResult)
                      }
                    >
                      <Typography variant="h6">Search Results</Typography>

                      <Btn
                        attrBtn={{
                          color: "primary",

                          onClick: () => {
                            handleReset();
                            history(`/add-notification-template`);
                          },
                          style: { marginLeft: "20px" },
                        }}
                      >
                        <Icon style={{ fontSize: "25px" }} name="plus" />
                        Add Notification Template
                      </Btn>
                    </AccordionSummary>
                    <AccordionDetails>
                      {/* {loadingSearch && loadingPanel} */}
                      <div>
                        {sortedColumns.length > 0 && (
                          <TelerikDataTable
                            id={id}
                            pageSize={pageSize}
                            totalCount={rowCount}
                            skip={(page - 1) * pageSize}
                            take={pageSize}
                            data={results || []}
                            sortData={sortData}
                            onFilterChange={handleFilterChange}
                            onSortChange={handleSortChange}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePageSizeChange}
                            selectedColumns={sortedColumns}
                            setSortedColumns={setSortedColumns}
                            loading={loadingSearch}
                            actions={actions}
                            gg1ExportParams={gg1ExportParams}
                            setChooseFilterMethod={setChooseFilterMethod}
                            chooseFilterMethod={chooseFilterMethod}
                          ></TelerikDataTable>
                        )}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    </ErrorBoundary>
  );
}
export default NotificationTemplateListing;
